module.exports = __webpack_public_path__ + "img/niklas.8ef81ddc.jpeg";